import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router'
import { Modal, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab'

// Styles
import '../../assets/styles.css'

// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default function WithdrawFundsComponent() {

    const history = useHistory()

    // Loading
    const [isLoadingModalOpen, setLoaginModalOpen] = useState(false)

    // Snackbar
    const [alertSeverity, setAlertSeverity] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertDuration, setAlertDuration] = useState(3000)
    const [alertOpen, setAlertOpen] = useState(false)

    function showAlert(severity, message, duration) {
        setAlertSeverity(severity)
        setAlertMessage(message)
        setAlertDuration(duration)
        setAlertOpen(true)
    }

    function checkedLogedIn() {
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
                history.replace('/login')
            } else {
                getWithdrawRequest()
            }
        })
    }

    // Withdraw requests
    
    const [isTransferModalOpen, setTransferModalOpen] = useState(false)

    let withdrawList = []
    function getWithdrawRequest() {

        withdrawList = []

        let html = ''

        firebase.firestore().collection('withdrawRequest').get().then((query) => {

            query.forEach((doc) => {
                const data = doc.data()

                withdrawList.push(data)
            })

            withdrawList.reverse()

            withdrawList.forEach((doc) => {

                html += '<tr>' +
                '<td>' + doc.requestID + '</td>' +
                '<td>' + doc.type + '</td>' +
                '<td>' + (Math.round(Number.parseFloat(doc.amount) * 100) / 100).toFixed(2).toString() + '</td>' +
                '<td>' +
                '<button id="' + doc.requestID + '-copy" type="button" class="btn btn-secondary-transparent" style="margin-right: 5px;" >  <i class="fas fa-info-circle" style="font-size: 20px;"></i>  </button>' +
                '<button id="' + doc.requestID + '-decline" type="button" class="btn btn-primary-transparent" style="margin-right: 5px;" >  <i class="fas fa-times-circle" style="font-size: 20px;"></i>  </button>' +
                '<button id="' + doc.requestID + '-done" type="button" class="btn btn-green-transparent">  <i class="fas fa-check-circle" style="font-size: 20px;"></i>  </button>' +
                '</td>' +
                '</tr>'
            })

            document.getElementById('listBody').innerHTML = html

            withdrawList.forEach((element) => {

                // Copy button
                document.getElementById(element.requestID + '-copy').addEventListener('click', () => {
                    textToClipboard(element.sendMethod)
                    if(element.type === 'Transfer') {

                        setTransferModalOpen(true)
                        const transferHTML = 'Nombre: <span style="font-weight: bold; color: #FB3D44;" >' + element.username + '</span> <br/>' +
                            'Número de cédula: <span style="font-weight: bold; color: #FB3D44;" >' + element.idCardN + '</span> <br/>' +
                            'Correo: <span style="font-weight: bold; color: #FB3D44;" >' + element.email + '</span> <br/>' +
                            'Número de teléfono: <span style="font-weight: bold; color: #FB3D44;" >' + element.telNumber + '</span> <br/>' +
                            'Nombre del banco: <span style="font-weight: bold; color: #FB3D44;" >' + element.bankName + '</span> <br/>' +
                            'Tipo de cuenta: <span style="font-weight: bold; color: #FB3D44;" >' + element.accountType + '</span> <br/>' +
                            'Número de cuenta: <span style="font-weight: bold; color: #FB3D44;" >' + element.accountN + '</span> <br/>' + 
                            'Total a pagar: <span style="font-weight: bold; color: #FB3D44;" >' + (Math.round(Number.parseFloat(element.amount) * 100) / 100).toFixed(2).toString() + ' $</span> <br/>'

                        document.getElementById('transferModalBody').innerHTML = transferHTML

                    } else {
                        showAlert('success', 'Cuenta de PayPal copiada al portapapeles.', 3000)
                    }
                })

                // Decline button
                document.getElementById(element.requestID + '-decline').addEventListener('click', () => {

                    setLoaginModalOpen(true)

                    firebase.firestore().collection('withdrawRequest').doc(element.requestID.toString()).delete().then(() => {

                        firebase.firestore().collection('users').doc(element.userID.toString()).get().then((doc) => {
                            const data = doc.data()

                            const wallet = Number.parseFloat(data.wallet)
                            const newWallet = wallet + Number.parseFloat(element.amount)
                            const updatedWallet = (Math.round(newWallet * 100) / 100).toFixed(2).toString()

                            firebase.firestore().collection('users').doc(element.userID.toString()).update({wallet:updatedWallet}).then(() => {
                                getWithdrawRequest()
                                setLoaginModalOpen(false)
                                showAlert('success', 'Petición rechazada con éxito.', 3000)

                                window.open('mailto:' + data.email + '?subject=Retirada%20de%20fondos%20rechazada&body=Hemos%20decidio%20rechazar%20tu%20retirada%20de%20fondos%20de%20' + (Math.round(Number.parseFloat(element.amount) * 100) / 100).toFixed(2).toString() + '$,%20vuelve%20a%20intentarlo%20en%20otro%20momento.');
                            })
                        })

                    }).catch((error) => {
                        setLoaginModalOpen(false)
                        console.error(error)
                        showAlert('error', 'Ha ocurrido un error, intentalo más tarde.', 3000)
                    })

                })

                // Done button
                document.getElementById(element.requestID + '-done').addEventListener('click', () => {

                    setLoaginModalOpen(true)

                    firebase.firestore().collection('withdrawRequest').doc(element.requestID.toString()).delete().then(() => {

                        getWithdrawRequest()
                        setLoaginModalOpen(false)
                        showAlert('success', 'Petición aceptada con éxito.', 3000)

                    }).catch((error) => {
                        setLoaginModalOpen(false)
                        console.error(error)
                        showAlert('error', 'Ha ocurrido un error, intentalo más tarde.', 3000)
                    })
                })
            })
        })
    }

    function textToClipboard (text) {
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
    }

    useEffect(() => {
        checkedLogedIn()
    }, [])

    return(
        <div>
            <br></br>
            <div className="container" >
                <div className="row" >
                    <div className="col text-center" >
                        <h1 style={{ color: '#FB3D44'}} >
                            PETICIONES DE FONDOS
                        </h1>
                    </div>
                </div>
                <div className='row blue-divider'></div>
                <br></br>
                <div className='row' >
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th scope='col' >ID Petición</th>
                                <th scope='col' >Método de retirada</th>
                                <th scope='col' >Suma ($)</th>
                                <th scope='col' >Acciones</th>
                            </tr>
                        </thead>
                        <tbody id='listBody' >
                        </tbody>
                    </table>
                </div>
            </div>
            <br></br>
            {/**
             * 
             * MODAL ZONE
             * 
             */}
            <Modal
            disableEnforceFocus
            open={isLoadingModalOpen} >
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}} >
                    <CircularProgress color='inherit' style={{ color: '#FB3D44', marginTop: 25 }} />
                </div>
            </Modal>
            <Modal
            disableEnforceFocus
            open={isTransferModalOpen} >
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}} >
                    <div style={{display: 'flex', backgroundColor:'white', width: '50%', borderRadius: 10, flexDirection: 'column', padding: 20 }} >
                        <button type='button' style={{ alignSelf: 'flex-end', marginTop: -10, marginRight: -10 }} className='btn'
                        onClick={() => {setTransferModalOpen(false)}} >
                            <i className="fas fa-times"></i>
                        </button>
                        <p style={{ lineHeight: '2' }} id='transferModalBody' >
                        </p>
                    </div>
                </div>
            </Modal>
            {/**
             * 
             * SNACKBAR
             * 
             */}
            <Snackbar
            open={alertOpen}
            autoHideDuration={alertDuration}
            onClose={() => {
                setAlertOpen(false)
            }} >
                <Alert 
                variant='filled'
                severity={alertSeverity} >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/withdrawFunds/WithdrawFundsComponent.js